import { ProductAdsComponent } from '@/scopes/product-ads/components/ProductAds'
import { ProductAdsList } from '@/scopes/product-ads/components/ProductAdsList'
import { useDestinationFilteredProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { tk } from '@sunwebgroup/ui-components'
import { useRef } from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  padding: ${tk('spacing_lg')} ${tk('spacing_md')};
  display: flex;
  flex-direction: column;

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_3xl')};
  }
  background: #ffffff;
  border-radius: 12px; //TODO: Use token when available
  border: 2px solid #e7e0d7;
`

export function SearchTileProductAds({ infoLabel, infoContent, contextItemId, headerTitle }: {
  infoLabel: string
  infoContent: string
  headerTitle: string
  contextItemId: string
}) {
  const { isLoading, data } = useDestinationFilteredProductAds(contextItemId)
  const productAdsRef = useRef(null)
  useProductAdsListViewed(data, 'sponsored_plp', productAdsRef)

  const content = !data || data.length === 0
    ? null
    : (
        <Wrapper data-qa="product-ads">
          <ProductAdsComponent infoLabel={infoLabel} infoContent={infoContent} headerTitle={headerTitle}>
            <ProductAdsList data={data} isLoading={isLoading} type="sponsored_plp" />
          </ProductAdsComponent>
        </Wrapper>
      )

  return (
    <div ref={productAdsRef}>
      {content}
    </div>
  )
}
